// extracted by mini-css-extract-plugin
export default {"card":"number-chip_card__bzGkf"};